import React from 'react';
import useRestApi from './useRestApi';
import { apiUrl } from '../utils/apiUrl';
import { useTenantContext } from '../contexts/TenantContext';

export const useLearnInstance = () => {
  const tenantContext = useTenantContext();

  const childIds = React.useMemo(
    () => tenantContext.tenant?.tenantChildren ?? [],
    [tenantContext.tenant?.tenantChildren],
  );

  const [childIndex, setChildIndex] = React.useState(0);
  const [learnInstanceId, setLearnInstanceId] = React.useState<string | undefined>(undefined);
  const [learnInstance, setLearnInstance] = React.useState<any | undefined>(undefined);

  const childInfoApi = useRestApi<any>(apiUrl('tenancy', `tenants/${childIds[childIndex]}`), {
    manual: true,
  });

  React.useEffect(() => {
    if (learnInstanceId) return;
    if (childIndex >= childIds.length) return;
    if (tenantContext.tenant?.tenantType !== 'Learn') return;
    childInfoApi.fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [childIndex, childIds.length, learnInstanceId]);

  React.useEffect(() => {
    const info = childInfoApi.data;
    if (!info) return;

    if (info.tenantType === 'LearnInstance') {
      setLearnInstanceId(info.id);
      setLearnInstance(info);
    } else {
      setChildIndex((v) => v + 1);
    }
  }, [childInfoApi.data]);

  const resolving =
    tenantContext.tenant?.tenantType === 'Learn' &&
    !learnInstanceId &&
    !childInfoApi.error &&
    childIndex < childIds.length;

  return {
    learnInstanceId,
    learnInstance,
    resolving,
    loading: childInfoApi.loading,
    error: childInfoApi.error,
  };
};
